import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { RouterModule } from '@angular/router';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopNavbarComponent } from './components/top-navbar/top-navbar.component';
import { LayoutComponent } from './layout.component';
import { LoginDlgComponent } from './login-dlg/login-dlg.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgZorroAntdModule } from '../ng-zorro-antd.module';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { WMSMPagesModule } from '../WMSM-Pages/WMSMPages.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AccountInfoComponent } from './components/top-navbar/account-info/account-info.component';
import { HelpInfoComponent } from './components/top-navbar/help-info/help-info.component';
import { SideNavbarComponent } from './components/side-navbar/side-navbar.component';
import { SwitchDialogComponent } from './components/switch-dialog/switch-dialog.component';
import { SwitchIdentityComponent } from './components/switch-identity/switch-identity.component';
export function createTranslateHttpLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}


@NgModule({
  declarations: [
    LayoutComponent,
    TopNavbarComponent,
    LoginDlgComponent,
    AccountInfoComponent,
    HelpInfoComponent,
    SideNavbarComponent,
    SwitchDialogComponent,
    SwitchIdentityComponent,
  ],
  imports: [
    CommonModule,
    NzLayoutModule,
    RouterModule,
    NzIconModule,
    NzMenuModule,
    NzDropDownModule,
    NzBadgeModule,
    //I18N
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateHttpLoader,
        deps: [HttpClient],
      },
    }),
    WMSMPagesModule,
    NgZorroAntdModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [
    NgZorroAntdModule
  ],
  exports: [LayoutComponent]
})
export class LayoutModule { }
